<template>
  <div class="px-4 py-3">
    <div class="flex items-center justify-between gap-8">
      <span class="text-sm">{{ $t('W: Vis arkiverede') }}</span>
      <button
        class="relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors duration-200"
        :class="isArchived ? '' : 'bg-border-subtle'"
        :style="isArchived ? 'background-color: var(--color-action)' : ''"
        @click="toggle">
        <span
          class="pointer-events-none mt-0.5 inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200"
          :class="isArchived ? 'translate-x-4' : 'translate-x-0.5'" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { usePricingSegmentStore } from '@/stores/pricingSegmentStore'
import { mapState } from 'pinia'

export default {
  name: 'PricingSegmentStateFilterMenu',

  emits: ['close'],

  computed: {
    ...mapState(usePricingSegmentStore, ['listStateFilter']),

    isArchived(): boolean {
      return this.listStateFilter === 'archived'
    },
  },

  methods: {
    toggle() {
      const store = usePricingSegmentStore()
      store.listStateFilter = this.listStateFilter === 'active' ? 'archived' : 'active'
    },
  },
}
</script>
